<div class="tabbed-header">
  <h1>{{ "changeMasterPassword" | i18n }}</h1>
</div>

<div class="tw-max-w-lg tw-mb-12">
  <bit-callout type="warning">{{ "loggedOutWarning" | i18n }}</bit-callout>
  <auth-change-password [inputPasswordFlow]="inputPasswordFlow"></auth-change-password>
</div>

<app-webauthn-login-settings></app-webauthn-login-settings>
